'use client'

import { SplashScreen } from '@capacitor/splash-screen'
import { useEffect } from 'react'

export function SplashScreenHandler() {
  useEffect(() => {
    const hideSplashScreen = async () => {
      try {
        // Add a small delay to ensure layout is stable
        setTimeout(async () => {
          await SplashScreen.hide()
        }, 500)
      } catch (err) {
        // Ignore errors in non-Capacitor environments
        console.debug(
          'Error hiding splash screen (likely not in Capacitor):',
          err,
        )
      }
    }

    hideSplashScreen()
  }, [])

  return null
}
